import { Button } from "@interstate/components/Button";
import styled from "styled-components";

export interface MessagePreviewButtonProps {
  /** Callback function called when preview button is clicked */
  onPreview: () => void;
}

const ButtonContainer = styled.div`
  margin-top: 10px;
  margin-right: 10px;
  float: right;
`;

export function MessagePreviewButton(props: MessagePreviewButtonProps) {
  return (
    <ButtonContainer>
      <Button
        buttonStyle="secondary"
        data-testid="message-preview-button"
        id="conversation-preview-button"
        onClick={props.onPreview}
      >
        Preview
      </Button>
    </ButtonContainer>
  );
}

export default MessagePreviewButton;
